import { useState } from "react";

const HeroBackground = ({ src, position = "center center" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <img
        src={src}
        alt=""
        role="presentation"
        aria-hidden="true"
        onLoad={() => setLoaded(true)}
        className="absolute inset-0 w-full h-full"
        style={{
          objectFit: "cover",
          objectPosition: position,
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.8s ease",
          willChange: "opacity",
        }}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
      <div
        className="absolute inset-0 bg-[#0A0A0A] transition-opacity duration-700"
        style={{ opacity: loaded ? 0 : 1, pointerEvents: "none" }}
      />
    </>
  );
};

export default HeroBackground;
